import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/Setting2FilledStandard.js";
import d from "../components/PfIcon.js";
const t = (r, e) => {
  const a = {
    ...r,
    ...e.attrs
  };
  return i(d, n(a, {
    icon: o
  }), null);
};
t.displayName = "Setting2FilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
